import React, { useState, useEffect } from 'react';
import './OtherPractices.css';
import otherPracticeImg from '../../assets/images/Home/other-pracitces.png';

const OtherPractices = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  const otherPracticesArr = [
    'Accounting services', 'Attorney at law', 'Corporate services', 'Drafting contracts', 
    'FinTech Services', 'Forex trading license', 'Financial license', 'Forex broker license', 
    'ICO consulting services', 'Investment', 'Opening an account in the payment system', 
    'Certificates of good standing, incumbency', 'Registration of trademarks', 'Tax consulting services', 
    'Valuation and business-modeling', 'Opening a cryptocurrency debit card', 'Citizenship', 
    'Ready-made cryptocurrency licenses for sale', 'Due diligence', 'Fintech Software Development', 
    'Gambling', 'International business certification', 'Investment in real estate', 'Legal Opinion', 
    'Opening merchant account', 'Redomicile of companies', 'Support IPO', 'Trust registration'
  ];

  // Определение типа устройства
  useEffect(() => {
    const checkIfMobile = () => {
      // 1024px - брейкпоинт для планшетов и мобилок
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Определяем, какие элементы показывать
  const shouldShowAll = !isMobile || isExpanded;
  const itemsToShow = shouldShowAll 
    ? otherPracticesArr 
    : otherPracticesArr.slice(0, 14);
  
  // Разделяем элементы на две колонки
  const midIndex = Math.ceil(itemsToShow.length / 2);
  const leftColumnItems = itemsToShow.slice(0, midIndex);
  const rightColumnItems = itemsToShow.slice(midIndex);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="other-practices-container">
      <div className="other-practices-left">
        <h2 className="other-practices-title">
          Other Practices
        </h2>
        <div className="other-practices-keys">
          <div>
            {leftColumnItems.map((el, index) => (
              <div className="other-practices-items-left" key={index}>
                {el}
              </div>
            ))}
          </div>
          <div>
            {rightColumnItems.map((el, index) => (
              <div className="other-practices-items-right" key={index + leftColumnItems.length}>
                {el}
              </div>
            ))}
          </div>
        </div>
        
        {/* Кнопка показывается только на мобилках и планшетах */}
        {isMobile && otherPracticesArr.length > 14 && (
          <button 
            className="show-more-button" 
            onClick={toggleExpand}
          >
            {isExpanded ? 'Show Less - ' : 'Show More + '}
          </button>
        )}
      </div>
      <div className="other-practices-right">
        <img src={otherPracticeImg} alt="Other practices" />
      </div>
    </div>
  );
};

export default OtherPractices;